<template>
    <PreferencesSelectType :type="'SMOKING'" />
</template>

<script>
import PreferencesSelectType from './components/PreferencesSelectType'

export default {
    name: 'PreferencesSmokingTypePage',
    components: { PreferencesSelectType },
}
</script>
